import React, { createContext, useState, useEffect } from "react";

export const ExploreContext = createContext();

const LOCAL_STORAGE_KEY = "app_filters";

export const ContextProvider = ({ children }) => {
  const getInitialFilters = () => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (stored) {
        try {
          return JSON.parse(stored);
        } catch {
          return null;
        }
      }
    }
    return null;
  };

  const initialFilters = getInitialFilters();

  const [filterData, setFilterData] = useState({});

  const [selectedTags, setSelectedTags] = useState(
    initialFilters?.selectedTags || {},
  );
  const [sliderValues, setSliderValues] = useState(
    initialFilters?.sliderValues || {},
  );
  const [expandedTags, setExpandedTags] = useState(
    initialFilters?.expandedTags || {},
  );
  const [isNotInterested, setIsNotInterested] = useState(false);

  const [cardLayout, setCardLayout] = useState("grid");

  const [isLoading, setLoading] = useState(true);

  const [tabActive, setTabActive] = useState("1");

  const [selectedList, setSelectedList] = useState(0);

  useEffect(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setSelectedTags(parsed.selectedTags || {});
        setSliderValues(parsed.sliderValues || {});
        setExpandedTags(parsed.expandedTags || {});
      } catch (e) {
        console.error("Error parsing stored filters", e);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify({ selectedTags, sliderValues, expandedTags }),
    );
  }, [selectedTags, sliderValues, expandedTags]);

  const clearAll = () => {
    setSelectedTags({});
    setSliderValues({});
    setExpandedTags({});
    setFilterData({});
  };

  return (
    <ExploreContext.Provider
      value={{
        selectedTags,
        setSelectedTags,
        sliderValues,
        setSliderValues,
        expandedTags,
        setExpandedTags,
        clearAll,
        cardLayout,
        setCardLayout,
        isNotInterested,
        setIsNotInterested,
        isLoading,
        setLoading,
        tabActive,
        setTabActive,
        selectedList,
        setSelectedList,
        filterData,
        setFilterData,
      }}
    >
      {children}
    </ExploreContext.Provider>
  );
};
